import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
// import PropTypes from "prop-types";
import { RiArrowDownSLine, RiSortDesc } from "react-icons/ri";
import { GrMenu } from "react-icons/gr";
import { BsFillGridFill } from "react-icons/bs";
import { FaWineBottle, FaWineGlassAlt, FaTimes, FaMagic } from "react-icons/fa";
import { CiFilter } from "react-icons/ci";
import { MdCancel } from "react-icons/md";
import search from "../../assets/admin/search.svg";
import { IoIosArrowBack, IoIosArrowDropdown, IoMdClose } from "react-icons/io";
import { AiOutlineLike } from "react-icons/ai";
import { useTranslation } from 'react-i18next';
import Loader from "../../utils/Loader";

const WineProduct = (props) => {
  const {
    isLoading,
    minPrice,
    setMinPrice,
    maxPrice,
    setMaxPrice,
    priceType,
    setPriceType,
    wineData,
    winesData,
    priceFilter,
    setPriceFilter,
    filteredNation,
    setFilteredNation,
    filteredRegion,
    setFilteredRegion,
    filteredWine,
    setFilteredWine,
    filteredProductType,
    setFilteredProductType,
  } = props;

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const qrcode = queryParams.get('qrcode');
  const navigate = useNavigate();
  const { rest_name } = useParams();
  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;
  const token = localStorage.getItem("token");
  const { t } = useTranslation();

  const [filteredNationArray, setFilteredNationArary] = useState([]);
  const [filteredRegionArray, setFilteredRegionArary] = useState([]);
  const [filteredWineArray, setFilteredWineArary] = useState([]);
  const [filteredProductTypeArray, setFilteredProductTypeArary] = useState([]);
  const [userType, setUserType] = useState("");

  const [showMore, setShowMore] = useState(true);
  const [viewMode, setVideMode] = useState("Grid");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [wineInfo, setWineInfo] = useState();
  const [searchQuery, setSearchQuery] = useState("");

  // const [numberOfProducts, setNumberOfProducts] = useState(21);
  const [expandedItems, setExpandedItems] = useState({});
  const [wineId, setWineId] = useState("");
  const [optionsData, setOptionsData] = useState("");
  const [openSection, setOpenSection] = useState(null);
  const [showFilterForMobile, setShowFilterForMobile] = useState(false);
  const wineListID = wineData?.wineList?.id;
  const toggleDescription = (index) => {
    setExpandedItems((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const [showOption, setShowOption] = useState({
    nation: false,
    region: false,
    wine: false,
    price: false,
    product_type: false,
    price_range: false,
  });

  const toggleDropdown = (key) => {
    setShowOption((prev) => ({
      nation: false,
      region: false,
      wine: false,
      product_type: false,
      price_range: false,
      [key]: !prev[key],
    }));
  };

  const getCategoryData = useCallback(async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/v1/home-page/wine-filter-options?slug=${rest_name}&wine_list_id=${wineListID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = response.data;
      setFilteredNationArary(data?.nations || []);
      setFilteredRegionArary(data?.regions || []);
      setFilteredWineArary(data?.grape_varieties || []);
      setFilteredProductTypeArary(data?.product_types || []);
    } catch (error) {
      console.error("Error fetching wine data:", error);
    }
  }, [apiUrl, rest_name, token, wineListID]);

  // Filter Toggle Functions
  const handleNationFilter = (nation) => {
    if (!filteredNation.includes(nation)) {
      setFilteredNation((prevState) => [...prevState, nation]);
    } else {
      setFilteredNation((prevState) => prevState.filter((n) => n !== nation));
    }
  };

  const handleRegionFilter = (region) => {
    if (!filteredRegion.includes(region)) {
      setFilteredRegion((prevState) => [...prevState, region]);
    } else {
      setFilteredRegion((prevState) => prevState.filter((n) => n !== region));
    }
  };

  const handleWineFilter = (wine) => {
    if (!filteredWine.includes(wine)) {
      setFilteredWine((prevState) => [...prevState, wine]);
    } else {
      setFilteredWine((prevState) => prevState.filter((n) => n !== wine));
    }
  };

  const handleProductTypeFilter = (productType) => {
    if (!filteredProductType.includes(productType)) {
      setFilteredProductType((prevState) => [...prevState, productType]);
    } else {
      setFilteredProductType((prevState) =>
        prevState.filter((n) => n !== productType)
      );
    }
  };

  const filteredNationArrays = filteredNationArray.filter((nation) =>
    nation.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const filteredRegionArrays = filteredRegionArray.filter((nation) =>
    nation.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const filteredWineArrays = filteredWineArray.filter((nation) =>
    nation.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const filteredProductTypeArrays = filteredProductTypeArray.filter((nation) =>
    nation.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleResize = () => {
    if (window.innerWidth >= 768) {
      setShowFilterForMobile(false);
    }
  };

  const handleResize2 = () => {
    if (window.innerWidth <= 768) {
      setShowFilterForMobile(true);
    }
  };

  const handleQRCodeClick = (item) => {
    setIsModalOpen(true);
    setWineInfo(item);
    setWineId(item?.pivot?.wine_stock_id);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleBackgroundClick = (e) => {
    if (e.target.id === "modal-background") {
      closeModal();
    }
  };

  // const toggleDescriptions = (index) => {
  //   setExpandedItems((prevState) => ({
  //     ...prevState,
  //     [index]: !prevState[index],
  //   }));
  // };

  const toggleSection = (sectionLabel) => {
    setOpenSection(openSection === sectionLabel ? null : sectionLabel);
  };

  const options = [
    {
      label: "Abbinamento Perfetto",
      icon: (
        <>
          <AiOutlineLike fontSize={23} color="black" gap={0} />
          <AiOutlineLike fontSize={23} color="black" />
          <AiOutlineLike fontSize={23} color="black" />
        </>
      ),
    },
    {
      label: "Buon Abbinamento",
      icon: <AiOutlineLike fontSize={23} color="black" />,
    },
    {
      label: "Abbinamento Creativo",
      icon: <FaMagic fontSize={23} color="black" />,
    },
  ];

  const dishData = useCallback(async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/v1/wines/${wineId}/pairedDishes`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setOptionsData(response?.data);
    } catch (error) {
      setOptionsData(error?.response?.data);
      console.error(error);
    }
  }, [apiUrl, token, wineId]);

  useEffect(() => {
    const role = localStorage.getItem("Role");
    setUserType(role);
  }, []);

  useEffect(() => {
    const fetchCategoryData = async () => {
      await getCategoryData();
    };
    fetchCategoryData();
  }, [wineData, getCategoryData]);

  useEffect(() => {
    setSearchQuery("");
  }, [showOption]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        setShowOption({ stato: false });
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize2);
    return () => {
      window.removeEventListener("resize", handleResize2);
    };
  }, []);

  useEffect(() => {
    if (wineId) {
      dishData();
    }
  }, [isModalOpen, wineId, dishData]);

  useEffect(() => {
    if (qrcode === 'true') {
      localStorage.removeItem("Role");
      localStorage.removeItem("token");
      localStorage.removeItem("currentRestId");
      localStorage.removeItem("loginUserId");
      localStorage.removeItem("type");
      localStorage.removeItem("RoleName");
      localStorage.removeItem("RoleId");

      console.log('LocalStorage cleared because qrcode=true');
    }
  }, [qrcode]);

  return (
    <div className="w-full flex items-center justify-center p-5 :p-24">
      <div className={`${showMore ? "w-full md:w-[85%]" : "w-[95%]"}`}>
        {wineData?.wineList?.name && (
          <h1 className="poppins-medium w-full text-center sm:text-[42px] text-[35px] sm:my-5 my-3 text-[#8B2433] uppercase">
            {wineData?.wineList?.name || "N/A"}
          </h1>
        )}
        <div className="mt-4 bg-[#f8f1f1] sm:px-8 px-3 py-5 rounded-3xl flex justify-center items-center">
          <div className="w-full flex flex-col">
            <div className="flex justify-between pb-2 border-b-2 border-[#EBE8E7]">
              <h1 className="text-xl w-full flex items-center justify-between poppins-medium">
                {wineData?.wineList?.is_show_filter === 1 ? `${t('wineProductPage.filter')} :` : ""}
              </h1>
              <div className="flex gap-3">
                <button
                  className={
                    viewMode === "Grid"
                      ? "p-2 rounded-md border-2 border-[#BCB1B1] bg-[#BCB1B1]"
                      : "p-2 rounded-md border-2 border-[#BCB1B1]"
                  }
                  onClick={() => {
                    setVideMode("Grid");
                    if (viewMode !== "Grid") {
                      setShowMore(true);
                    }
                  }}
                >
                  <BsFillGridFill
                    className="text-2xl"
                    fill={viewMode === "Grid" ? "white" : "#CF8993"}
                  />
                </button>
                <button
                  className={
                    viewMode === "List"
                      ? "p-2 rounded-md border-2 border-[#BCB1B1] bg-[#CF8993]"
                      : "p-2 rounded-md bg-transparent  border-2 border-[#141414]"
                  }
                  onClick={() => {
                    setVideMode("List");
                    if (viewMode === "Grid") {
                      setShowMore(true);
                    }
                  }}
                >
                  <GrMenu
                    className="text-2xl"
                    color={viewMode === "List" ? "white" : "#CF8993"}
                  />
                </button>
              </div>
              {wineData?.wineList?.is_show_filter === 1 && (
                <div className="sm:hidden block items-center justify-center ml-1">
                  {showFilterForMobile ? (
                    <CiFilter
                      onClick={() => {
                        setShowFilterForMobile(!showFilterForMobile);
                      }}
                      color="gray"
                      className="m-2"
                      size={"35px"}
                    />
                  ) : (
                    <MdCancel
                      onClick={() => {
                        setShowFilterForMobile(!showFilterForMobile);
                      }}
                      color="gray"
                      className="m-2"
                      size={"35px"}
                    />
                  )}
                </div>
              )}
            </div>
            {wineData?.wineList?.is_show_filter === 1 && (
              <>
                {(filteredNation.length > 0 ||
                  filteredRegion.length > 0 ||
                  filteredWine.length > 0 ||
                  filteredProductType.length > 0) && (
                    <div className="flex flex-col gap-5 pt-4 pb-1">
                      <h1 className="text-lg font-medium">{t('wineProductPage.selectedFilter')}</h1>
                      <div className="flex flex-wrap gap-3">
                        {filteredNation.length > 0 &&
                          filteredNation?.map((item) => {
                            return (
                              <div
                                key={item}
                                className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
                              >
                                <p className="m-0 w-fit text-sm">{item}</p>
                                <FaTimes
                                  className="text-red-500 cursor-pointer"
                                  onClick={() => handleNationFilter(item)}
                                  title="Remove"
                                />
                              </div>
                            );
                          })}
                        {filteredRegion.length > 0 &&
                          filteredRegion?.map((item) => {
                            return (
                              <div
                                key={item}
                                className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
                              >
                                <p className="m-0 w-fit text-sm">{item}</p>
                                <FaTimes
                                  className="text-red-500 cursor-pointer"
                                  onClick={() => handleRegionFilter(item)}
                                  title="Remove"
                                />
                              </div>
                            );
                          })}
                        {filteredWine.length > 0 &&
                          filteredWine?.map((item) => {
                            return (
                              <div
                                key={item}
                                className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
                              >
                                <p className="m-0 w-fit text-sm">{item}</p>
                                <FaTimes
                                  className="text-red-500 cursor-pointer"
                                  onClick={() => handleWineFilter(item)}
                                  title="Remove"
                                />
                              </div>
                            );
                          })}
                        {filteredProductType.length > 0 &&
                          filteredProductType?.map((item) => {
                            return (
                              <div
                                key={item}
                                className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
                              >
                                <p className="m-0 w-fit text-sm">{item}</p>
                                <FaTimes
                                  className="text-red-500 cursor-pointer"
                                  onClick={() => handleProductTypeFilter(item)}
                                  title="Remove"
                                />
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  )}
                <div
                  className={`${showFilterForMobile
                    ? "hidden transition-all duration-500 ease-in-out"
                    : ""
                    } flex flex-wrap xl:flex-no-wrap gap-2 mt-5`}
                >
                  {/* <div className="flex flex-1 flex-wrap xl:flex-no-wrap gap-2 pr-2"> */}
                  <div className="relative w-full sm:w-1/3 lg:w-[20%] xl:w-auto xl:flex-1 group dropdown-container">
                    <button
                      className={`${showOption.nation
                        ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                        : "rounded-full"
                        } border bg-[#f8f1f1] border-[#8B24335C] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                      onClick={() => toggleDropdown("nation")}
                    >
                      <span className="mr-2 flex items-center gap-3 text-xs xl:text-sm  poppins-medium">
                        {t('wineProductPage.nation')}
                      </span>
                      <RiArrowDownSLine
                        className={`transform transition-transform duration-300 ${showOption.nation ? "rotate-180" : ""
                          }`}
                        size={"20px"}
                      />
                    </button>
                    <div
                      className={`${showOption.nation
                        ? "opacity-100 z-50"
                        : "opacity-0 z-20 overflow-hidden"
                        } bg-[#f8f1f1] h-min max-h-[250px] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border border-[#8B24335C] transition-all duration-300 ease-in-out`}
                    >
                      <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                        <img
                          src={search}
                          className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                          alt="Search"
                        />
                        <input
                          type="text"
                          className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                          placeholder="..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                      {filteredNationArrays?.length > 0 ? (
                        filteredNationArrays.map((nation) => (
                          <label
                            htmlFor=""
                            key={nation}
                            className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse filter_list_btn"
                          >
                            <input
                              type="checkbox"
                              className="outline-none cursor-pointer"
                              checked={filteredNation.includes(nation)}
                              onChange={() => handleNationFilter(nation)}
                            />
                            <span className="text-[#6B6B6B]  rounded-md flex items-center gap-3 poppins-regular text-sm">
                              {nation}
                            </span>
                          </label>
                        ))
                      ) : (
                        <label
                          htmlFor=""
                          className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse  filter_list_btn"
                        >
                          <span className="text-[#6B6B6B] text-xs xl:text-sm  rounded-md flex items-center gap-3 poppins-regular text-sm">
                            {t('wineProductPage.noDataNation')}
                          </span>
                        </label>
                      )}
                    </div>
                  </div>
                  <div className="relative w-full sm:w-1/3 lg:w-[20%] xl:w-auto xl:flex-1 group dropdown-container">
                    <button
                      className={`${showOption.region
                        ? "border-b-0 rounded-tl-3xl rounded-tr-3xl"
                        : "rounded-full"
                        } border bg-[#f8f1f1] border-[#8B24335C] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                      onClick={() => toggleDropdown("region")}
                    >
                      <span className="mr-2 text-xs xl:text-sm  flex items-center gap-3 poppins-medium">
                        {t('wineProductPage.region')}
                      </span>
                      <RiArrowDownSLine
                        className={`transform transition-transform duration-300 ${showOption.region ? "rotate-180" : ""
                          }`}
                        size={"20px"}
                      />
                    </button>
                    <div
                      className={`${showOption.region
                        ? "opacity-100 z-50"
                        : "opacity-0 z-20 overflow-hidden"
                        } bg-[#f8f1f1] h-min max-h-[250px] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border border-[#8B24335C] transition-all duration-300 ease-in-out`}
                    >
                      <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                        <img
                          src={search}
                          className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                          alt="Search"
                        />
                        <input
                          type="text"
                          className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                          placeholder="..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                      {filteredRegionArrays?.length > 0 ? (
                        filteredRegionArrays?.map((region) => (
                          <label
                            htmlFor=""
                            key={region}
                            className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse  filter_list_btn"
                          >
                            <input
                              type="checkbox"
                              className="outline-none cursor-pointer"
                              checked={filteredRegion.includes(region)}
                              onChange={() => handleRegionFilter(region)}
                            />
                            <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                              {region}
                            </span>
                          </label>
                        ))
                      ) : (
                        <label
                          htmlFor=""
                          className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse filter_list_btn"
                        >
                          <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                            {t('wineProductPage.region')}
                          </span>
                        </label>
                      )}
                    </div>
                  </div>
                  <div className="relative w-full sm:w-1/3 lg:w-[20%] xl:w-auto xl:flex-1 group dropdown-container">
                    <button
                      className={`${showOption.wine
                        ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                        : "rounded-full"
                        } border bg-[#f8f1f1] border-[#8B24335C] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                      onClick={() => toggleDropdown("wine")}
                    >
                      <span className="mr-2 text-xs xl:text-sm  flex items-center gap-3 poppins-medium">
                        {t('wineProductPage.wineType')}
                      </span>
                      <RiArrowDownSLine
                        className={`transform transition-transform duration-300 ${showOption.wine ? "rotate-180" : ""
                          }`}
                        size={"20px"}
                      />
                    </button>
                    <div
                      className={`${showOption.wine
                        ? "opacity-100 z-50"
                        : "opacity-0 z-20 overflow-hidden"
                        } bg-[#f8f1f1] h-min max-h-[250px] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border border-[#8B24335C] transition-all duration-300 ease-in-out`}
                    >
                      <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                        <img
                          src={search}
                          className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                          alt="Search"
                        />
                        <input
                          type="text"
                          className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                          placeholder="..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                      {filteredWineArrays?.length > 0 ? (
                        filteredWineArrays?.map((wine) => (
                          <label
                            htmlFor=""
                            key={wine}
                            className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse filter_list_btn"
                          >
                            <input
                              type="checkbox"
                              className="outline-none cursor-pointer"
                              checked={filteredWine.includes(wine)}
                              onChange={() => handleWineFilter(wine)}
                            />
                            <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                              {wine}
                            </span>
                          </label>
                        ))
                      ) : (
                        <label
                          htmlFor=""
                          className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse filter_list_btn"
                        >
                          <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                            {t('wineProductPage.noDataWineType')}
                          </span>
                        </label>
                      )}
                    </div>
                  </div>
                  <div className="relative w-full sm:w-1/3 lg:w-[20%] xl:w-auto xl:flex-1 group dropdown-container">
                    <button
                      className={`${showOption.product_type
                        ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                        : "rounded-full"
                        } border bg-[#f8f1f1] border-[#8B24335C] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                      onClick={() => toggleDropdown("product_type")}
                    >
                      <span className="mr-2 text-xs xl:text-sm  flex items-center gap-3 poppins-medium">
                        {t('wineProductPage.productType')}
                      </span>
                      <RiArrowDownSLine
                        className={`transform transition-transform duration-300 ${showOption.product_type ? "rotate-180" : ""
                          }`}
                        size={"20px"}
                      />
                    </button>
                    <div
                      className={`${showOption.product_type
                        ? "opacity-100 z-50"
                        : "opacity-0 z-20 overflow-hidden"
                        } bg-[#f8f1f1] h-min max-h-[250px] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border border-[#8B24335C] transition-all duration-300 ease-in-out`}
                    >
                      <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                        <img
                          src={search}
                          className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                          alt="Search"
                        />
                        <input
                          type="text"
                          className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                          placeholder="..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                      {filteredProductTypeArrays?.length > 0 ? (
                        filteredProductTypeArrays?.map((productType) => (
                          <label
                            htmlFor=""
                            key={productType}
                            className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse  filter_list_btn"
                          >
                            <input
                              type="checkbox"
                              className="outline-none cursor-pointer"
                              checked={filteredProductType.includes(
                                productType
                              )}
                              onChange={() =>
                                handleProductTypeFilter(productType)
                              }
                            />
                            <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                              {productType}
                            </span>
                          </label>
                        ))
                      ) : (
                        <label
                          htmlFor=""
                          className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse  filter_list_btn"
                        >
                          <span className="text-[#6B6B6B] text-xs xl:text-sm  rounded-md flex items-center gap-3 poppins-regular text-sm">
                            {t('wineProductPage.noDataProductType')}
                          </span>
                        </label>
                      )}
                    </div>
                  </div>
                  <div className="relative w-full sm:w-1/3 lg:w-[28%] xl:w-auto xl:flex-1 group dropdown-container">
                    <button
                      className={`${showOption?.price_range
                        ? "min-max-btn border-b-0 rounded-tl-3xl rounded-tr-3xl"
                        : "rounded-full"
                        } border bg-[#f8f1f1] border-[#8B24335C] inline-flex justify-between items-center w-full md:w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                      onClick={() => toggleDropdown("price_range")}
                    >
                      <span className="mr-2 text-xs xl:text-sm  flex items-center gap-3 poppins-medium whitespace-nowrap text-sm">
                        {t('wineProductPage.PriceRange')}
                      </span>
                      <RiArrowDownSLine
                        className={`transform transition-transform duration-300 ${showOption.price_range ? "rotate-180" : ""
                          }`}
                        size={"20px"}
                      />
                    </button>
                    <div
                      className={`${showOption?.price_range
                        ? "opacity-100 z-[999]"
                        : "opacity-0 overflow-hidden z-20"
                        } bg-[#f8f1f1] h-fit max-h-[320px] overflow-hidden absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full md:w-full border border-[#8B24335C] transition-all duration-300 ease-in-out`}
                    >
                      <div className="flex gap-4 w-full items-center justify-between overflow-hidden">
                        <div className="w-[50%] border flex items-center justify-start">
                          <label
                            htmlFor=""
                            className="w-full border-b border-[#8b24331f] bg-white px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                          >
                            <input
                              type="text"
                              className="outline-none cursor-pointer w-full text-center text-sm md:text-base"
                              placeholder="Min"
                              value={minPrice}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,4}$/.test(value)) {
                                  setMinPrice(value);
                                  setPriceFilter("asc");
                                  setPriceType("bottle_price");
                                }
                              }}
                            />
                          </label>
                        </div>
                        <div className="w-[50%] border flex items-center justify-start">
                          <label
                            htmlFor=""
                            className="w-full border-b border-[#8B24335C]  bg-white px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                          >
                            <input
                              type="text"
                              className="outline-none cursor-pointer w-full text-center text-sm md:text-base"
                              placeholder="Max"
                              value={maxPrice}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,4}$/.test(value)) {
                                  setMaxPrice(value);
                                  setPriceFilter("asc");
                                  setPriceType("bottle_price");
                                }
                              }}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="relative group flex justify-end dropdown-container">
                    <button
                      className="bg-[#f8f1f1] border-[#8B24335C] w-12 inline-flex items-center px-3 py-0 outline-none text-[#DB7685] shadow-sm z-30"
                      onClick={() => toggleDropdown("price")}
                    >
                      <RiSortDesc
                        className={`text-md xl:text-2xl ml-auto transform transition-transform duration-300 ${showOption.price ? "rotate-180" : ""
                          }`}
                      />
                    </button>
                    <div
                      className={`${showOption.price
                        ? "opacity-100 z-50"
                        : "opacity-0 overflow-hidden z-20"
                        } bg-[#f8f1f1] h-fit max-h-[320px] min-w-[210px] overflow-hidden absolute top-[46px] pt-[9px] p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border border-[#8B24335C] transition-all duration-300 ease-in-out left-0 md:left-auto`}
                    >
                      <label
                        htmlFor=""
                        className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse  filter_list_btn"
                      >
                        <input
                          type="checkbox"
                          checked={
                            priceFilter === "desc" &&
                            priceType === "bottle_price"
                          }
                          className="outline-none cursor-pointer"
                          onChange={() => {
                            setPriceFilter("desc");
                            setPriceType("bottle_price");
                          }}
                        />
                        <span className="text-[#6B6B6B] text-xs xl:text-sm  rounded-md flex items-center gap-3 poppins-regular text-sm">
                          {t('wineProductPage.bottleHighToLow')}
                        </span>
                      </label>
                      <label
                        htmlFor=""
                        className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse  filter_list_btn"
                      >
                        <input
                          type="checkbox"
                          checked={
                            priceFilter === "asc" &&
                            priceType === "bottle_price"
                          }
                          className="outline-none cursor-pointer"
                          onChange={() => {
                            setPriceFilter("asc");
                            setPriceType("bottle_price");
                          }}
                        />
                        <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                          {t('wineProductPage.bottleLowToHigh')}
                        </span>
                      </label>
                      <label
                        htmlFor=""
                        className="border-b border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse  filter_list_btn"
                      >
                        <input
                          type="checkbox"
                          checked={
                            priceFilter === "desc" &&
                            priceType === "glass_price"
                          }
                          className="outline-none cursor-pointer"
                          onChange={() => {
                            setPriceFilter("desc");
                            setPriceType("glass_price");
                          }}
                        />
                        <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                          {t('wineProductPage.glassHighToLow')}
                        </span>
                      </label>
                      <label
                        htmlFor=""
                        className="px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                      >
                        <input
                          type="checkbox"
                          checked={
                            priceFilter === "asc" && priceType === "glass_price"
                          }
                          className="outline-none cursor-pointer"
                          onChange={() => {
                            setPriceFilter("asc");
                            setPriceType("glass_price");
                          }}
                        />
                        <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                          {t('wineProductPage.glassLowToHigh')}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                {/* </div> */}
              </>
            )}
          </div>
        </div>
        {isLoading ? (
          <div role="status" className="flex my-20 justify-center items-center loader-section sm:min-h-[200px] min-h-fit">
            {/* Loading spinner */}
            <Loader />
          </div>
        ) : (
          <div
            className={`${viewMode === "Grid"
              ? "p-1 grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 gap-[2.3%] gap-y-1"
              : "m-auto p-1 gap-[2.3%] gap-y-5 "
              }`}
          >
            {wineData?.wines?.length > 0 ? (
              winesData?.map((item, index) => (
                <div
                  className={`${viewMode === "Grid"
                    ? `rounded-3xl relative w-[100%] gap-4 flex-col md:flex-row ${!expandedItems[index]
                      ? ""
                      : item?.wine?.short_description
                        ? "h-fit"
                        : "h-[320px]"
                    } flex mt-5 bg-[#f8f1f1] justify-between p-4 pt-8 pb-6 ${!showOption.nation &&
                    !showOption.region &&
                    !showOption.product_type &&
                    !showOption.wine &&
                    !showOption.price &&
                    "z-50"
                    }`
                    : `rounded-3xl w-[100%] flex relative gap-4 mt-6 flex-col md:flex-row py-[32px] px-[15px] border-b-2 pb-4 bg-[#f8f1f1] md:border-0 ${!showOption.nation &&
                    !showOption.region &&
                    !showOption.product_type &&
                    !showOption.wine &&
                    !showOption.price &&
                    "z-50"
                    }`
                    }`}
                  key={index}
                >
                  <div
                    className={`${viewMode === "List" &&
                      "pb-3 md:pb-8 my-0 sm:max-w-[150px] max-w-[150px] sm:m-0 m-auto"
                      }`}
                  >
                    <div
                      className={`${viewMode === "List"
                        ? "bg-white flex items-center justify-center w-[150px] h-[200px] rounded-[20px]"
                        : "flex rounded-[20px] justify-center w-[96px] m-auto h-[150px] bg-white"
                        } cursor-pointer`}
                      onClick={() => handleQRCodeClick(item)}
                    >
                      {/* {item?.wine?.image ? (
                      <img
                        src={item?.wine?.image}
                        className={`${viewMode === "Grid"
                          ? "relative md:h-[150px] h-full w-[100%] bg-cover object-contain"
                          : "relative p-3 w-full h-full bg-cover object-contain"
                          }`}
                        alt="wineBottle"
                      />
                    ) : (
                      <img
                        src={defaultImage}
                        className={`${viewMode === "Grid"
                          ? "relative w-[100%] p-3 bg-cover object-cover"
                          : "relative p-3 bg-cover object-cover"
                          }`}
                        alt="wineBottle"
                      />
                    )} */}
                      {item?.wine?.image && (
                        <img
                          src={item?.wine?.image}
                          className={`${viewMode === "Grid"
                            ? "relative md:h-[150px] h-full w-[100%] bg-cover object-contain"
                            : "relative p-3 w-full h-full bg-cover object-contain"
                            }`}
                          alt="wineBottle"
                        />
                      )}
                    </div>
                  </div>
                  {/* Modal */}
                  {isModalOpen && (
                    <div
                      id="modal-background"
                      className="fixed inset-0 z-[999] flex items-center justify-center w-full h-full bg-transparent bg-opacity-50 backdrop-blur-sm"
                      onClick={handleBackgroundClick}
                    >
                      <div className="bg-[#fff] rounded-2xl shadow-2xl p-6 sm:w-[70%] w-[90%] relative wine-popup main-popup-content max-h-[564px] overflow-y-auto">
                        {/* Close Button */}
                        <div className="flex mb-4 justify-between gap-x-3">
                          <h2 className="w-[90%] text-2xl font-semibold text-[#8B2433] sm:text-center">
                            {wineInfo?.wine?.name
                              ? wineInfo?.wine?.name
                                .split(" ")
                                .slice(0, 10)
                                .join(" ")
                              : "N/A"}
                          </h2>
                          <button
                            onClick={closeModal}
                            className="text-[#8B2433] hover:text-gray-900 text-3xl"
                          >
                            <IoMdClose />
                          </button>
                        </div>
                        <div className="flex md:flex-row flex-col justify-between mt-10">
                          {wineInfo?.wine?.image &&
                            <div className="relative md:h-[200px] sm:h-[200px] h-[200px] rounded-3xl w-[150px] m-auto bg-transparent object-cover">
                              <img
                                src={wineInfo?.wine?.image}
                                className="h-full w-full object-contain"
                                alt="wineBottle"
                              />
                            </div>}
                          {wineInfo?.wine?.long_description &&
                            <div className="md:max-w-[60%]">
                              <div className="overflow-y-auto h-[150px] wine-popup">
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: wineInfo?.wine?.long_description || "N/A",
                                  }}
                                />
                              </div>
                            </div>}
                        </div>
                        {/* Sections */}
                        <div className="pt-[40px]">
                          {(() => {
                            const validSections = options?.filter(section =>
                              Array.isArray(optionsData) &&
                              optionsData?.some(item => item?.pairing_level === section?.label)
                            );

                            if (validSections?.length === 0) {
                              return (
                                <div className="text-center py-10">
                                  <p className="text-[#8B2433] text-lg font-medium">
                                    No wine pairing records found
                                  </p>
                                </div>
                              );
                            }

                            return validSections?.map((section) => (
                              <div key={section?.label} className="mb-4">
                                <button
                                  onClick={() => toggleSection(section?.label)}
                                  className="w-full text-left flex item-center items-center font-medium justify-between text-lg py-3 px-4 bg-[#8B2433] rounded-lg hover:bg-[#000] transition"
                                >
                                  <p className="pera-icons flex items-center gap-x-1 text-[#fff] sm:text-[18px] text-[15px]">
                                    {section?.label} {section?.icon}
                                  </p>
                                  <IoIosArrowDropdown
                                    className={`transform transition-transform duration-200 text-[#fff] ${openSection === section?.label ? "rotate-180" : "rotate-0"
                                      }`}
                                  />
                                </button>
                                {openSection === section?.label && (
                                  <div className="mt-2 space-y-2 transition-all duration-300 max-h-[250px] overflow-y-auto popup-wine">
                                    <div className="p-1 grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 gap-[2.3%] gap-y-5">
                                      {optionsData
                                        ?.filter(
                                          (item) => item?.pairing_level === section?.label
                                        )
                                        ?.map((item, index) => (
                                          <div
                                            key={index}
                                            className="relative w-[100%] gap-4 flex-col md:flex-row flex mt-5 bg-[#F6F6F6] justify-between p-4 rounded-[10px] pt-8 pb-6"
                                          >
                                            {/* Image Section */}
                                            <div>
                                              <div className="flex justify-center w-[120px] h-[120px] m-auto">
                                                {/* {item?.dish?.picture ? (
                                                <img
                                                  src={`${logoUrl}/${item?.dish?.picture}`}
                                                  className="relative rounded-[50%] h-full w-[100%] bg-cover object-cover"
                                                  alt="DishImage"
                                                />
                                              ) : (
                                                <img
                                                  src={defaultImage}
                                                  className="relative w-[100%] p-3 bg-cover object-cover"
                                                  alt="DishImage"
                                                />
                                              )} */}
                                                {item?.dish?.picture && (
                                                  <img
                                                    src={`${logoUrl}/${item?.dish?.picture}`}
                                                    className="relative rounded-[50%] h-full w-[100%] bg-cover object-cover"
                                                    alt="DishImage"
                                                  />
                                                )}
                                              </div>
                                            </div>

                                            {/* Details Section */}
                                            <div className="flex md:flex-row flex-col-reverse justify-between w-[100%] gap-5">
                                              <div className="flex flex-col gap-2 px-0">
                                                <p className="text-[#132F40] text-md font-[500]">
                                                  {item?.dish?.name}
                                                </p>
                                                <div className="gap-1">
                                                  <p className="text-[#505050] poppins-medium-italic text-xs">
                                                    {item?.dish?.description}
                                                  </p>
                                                  <p className="text-[#505050] poppins-medium-italic mt-2 text-xs">
                                                    {item?.dish?.allergens?.length
                                                      ? item?.dish?.allergens
                                                        ?.map((allergen) => allergen?.name_it)
                                                        .join(", ")
                                                      : ""}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                    </div>
                                  </div>
                                )}
                              </div>
                            ));
                          })()}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="w-full">
                    <div
                      className={`${viewMode === "Grid"
                        ? "flex md:flex-row flex-col-reverse justify-between w-[100%] gap-5"
                        : "flex justify-between w-[100%] sm:flex-row flex-col-reverse sm:gap-5 gap-2"
                        }`}
                    >
                      <div
                        className={`${viewMode === "Grid"
                          ? "flex flex-col gap-4 px-0"
                          : "flex flex-col gap-4 w-[100%] md:0 justify-top md:border-b-2border-[#D8B6BA]"
                          }`}
                      >
                        <p className="text-[#132F40] text-md font-[500]">
                          {item?.wine?.name} - {item?.wine?.product_type}
                        </p>
                        <div
                          className={`${viewMode === "Grid" ? "gap-1" : "sm:flex gap-1"
                            }`}
                        >
                          <p className="text-[#505050] poppins-medium-italic text-xs">
                            {item?.wine?.region}
                          </p>
                          <p className="text-[#505050] poppins-medium-italic text-xs">
                            {item?.wine?.nation}
                          </p>
                          <p className="text-[#505050] poppins-medium-italic text-xs">
                            {item?.wine?.grape_variety}
                          </p>
                        </div>

                      </div>

                      <div className="flex flex-col sm:justify-end justify-start  gap-5">
                        <div
                          className={
                            viewMode === "List"
                              ? " h-full w-fit flex sm:flex-col gap-2"
                              : "flex self-start md:flex flex-col items-start justify-start h-full text-end gap-2"
                          }
                        >
                          <span
                            className={
                              viewMode === "List"
                                ? "flex gap-2 w-24 items-center md:justify-center text-md h-auto"
                                : "flex gap-2 items-center sm:justify-start lg:justify-end text-md h-auto"
                            }
                          >
                            {item?.pivot?.is_show_bottle_price ? (
                              <>
                                <FaWineBottle className="text-xl text-red-600" />{" "}
                                <div className="w-[auto] h-fit text-left overflow-x-auto price-product">€{item?.pivot?.bottle_price}</div>
                              </>
                            ) : item?.pivot?.is_show_glass_price ? (
                              <>
                                <FaWineGlassAlt className="text-xl text-red-600" />
                                <div className="w-[auto] h-fit text-left overflow-x-auto price-product">
                                  €{item?.pivot?.glass_price}
                                </div>

                              </>
                            ) : null}
                          </span>

                          <span
                            className={
                              viewMode === "List"
                                ? "flex gap-2 w-24 items-center md:justify-center text-md h-auto"
                                : "flex gap-2 justify-end text-md h-full   "
                            }
                          >
                            {item?.pivot?.is_show_bottle_price &&
                              item?.pivot?.is_show_glass_price ? (
                              <>
                                <FaWineGlassAlt className="text-xl text-red-600" />
                                <div className="w-[auto] h-fit text-left overflow-x-auto price-product">
                                  €{item?.pivot?.glass_price}
                                </div>

                              </>
                            ) : (
                              <></>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="btn-both flex flex-col gap-4 my-2">
                      {item?.wine?.short_description && (
                        <div
                          className={`w-full poppins-light-italic overflow-hidden text-[#505050] text-xs transition-all duration-1000 ease-in-out
                          ${expandedItems[index]
                              ? "duration-1000"
                              : "h-8 duration-1000"
                            }
                        `}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item?.wine?.short_description,
                            }}
                          />
                        </div>
                      )}
                      {/* {viewMode === "List" && (
                    <p className="w-full poppins-semibold-italic text-[#292929] text-xs">
                      Incontra con spensieratezza tutta la cucina di mare
                    </p>
                  )} */}
                      {item?.wine?.short_description && (
                        <button
                          className={`${viewMode === "Grid"
                            ? "uppercase rounded-full px-2 max-w-[200px] py-2 text-[12px] border text-[#8B2433] border-[#8B2433] poppins-regular-italic"
                            : "uppercase border text-[#8B2433] border-[#8B2433] poppins-regular-italic w-max text-xs px-5 py-1 rounded-full"
                            }`}
                          onClick={() => toggleDescription(index)}
                        >
                          {expandedItems[index]
                            ? "MOSTRA MENO"
                            : "SCOPRI DI PIÙ"}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div
                role="status"
                className="flex my-20 justify-center items-center h-full"
              >
                <span className="sr-only">No Product Found</span>
              </div>
            )}
          </div>
        )}

        {/* Back button */}
        <div className="w-full flex justify-center mt-7">
          {!qrcode && ["customer", "admin", "restaurant", null].includes(userType) && (
            <button
              className="flex items-center px-2 py-1 bg-[#8A2533] text-white rounded-lg border-2 border-[#953543] hover:text-[#8A2533] hover:bg-[#f6efef] transition-colors group"
              onClick={() => navigate(-1)}
            >
              <IoIosArrowBack size={"25px"} color="white" className="group-hover:invert" />
              <span className="ml-2 poppins-regular">{t('landingPage.backButton')}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

// WineProduct.propTypes = {
//   isLoading: PropTypes.bool.isRequired,
//   minPrice: PropTypes.string.isRequired,
//   setMinPrice: PropTypes.func.isRequired,
//   maxPrice: PropTypes.string.isRequired,
//   setMaxPrice: PropTypes.func.isRequired,
//   priceType: PropTypes.string.isRequired,
//   setPriceType: PropTypes.func.isRequired,
//   wineData: PropTypes.shape({
//     wineList: PropTypes.shape({
//       id: PropTypes.number,
//       name: PropTypes.string,
//       is_show_filter: PropTypes.number,
//     }),
//     wines: PropTypes.arrayOf(
//       PropTypes.shape({
//         wine: PropTypes.shape({
//           name: PropTypes.string,
//           product_type: PropTypes.string,
//           region: PropTypes.string,
//           nation: PropTypes.string,
//           grape_variety: PropTypes.string,
//           image: PropTypes.string,
//           short_description: PropTypes.string,
//           long_description: PropTypes.string,
//         }),
//         pivot: PropTypes.shape({
//           is_show_bottle_price: PropTypes.bool,
//           is_show_glass_price: PropTypes.bool,
//           bottle_price: PropTypes.number,
//           glass_price: PropTypes.number,
//         }),
//       })
//     ),
//   }).isRequired,
//   priceFilter: PropTypes.string.isRequired,
//   setPriceFilter: PropTypes.func.isRequired,
//   filteredNation: PropTypes.arrayOf(PropTypes.string).isRequired,
//   setFilteredNation: PropTypes.func.isRequired,
//   filteredRegion: PropTypes.arrayOf(PropTypes.string).isRequired,
//   setFilteredRegion: PropTypes.func.isRequired,
//   filteredWine: PropTypes.arrayOf(PropTypes.string).isRequired,
//   setFilteredWine: PropTypes.func.isRequired,
//   filteredProductType: PropTypes.arrayOf(PropTypes.string).isRequired,
//   setFilteredProductType: PropTypes.func.isRequired,
// };

export default WineProduct;
